<!-- ForgotPasswordModal.vue -->

<script setup>
import { ref } from "vue";
import { useUserStore } from "@/stores/useUserStore";

const props = defineProps({
  // E-mail já conhecido (ex.: quem tentou se cadastrar com um e-mail que já
  // tem conta e clicou em "Esqueci minha senha"), para não digitar de novo.
  initialEmail: { type: String, default: "" },
});

const emit = defineEmits(["close", "success"]);
const userStore = useUserStore();

const email = ref(props.initialEmail || "");
const isLoading = ref(false);
const error = ref(null);
const successMessage = ref(null);

async function handleSubmit() {
  error.value = null;
  successMessage.value = null;

  if (!email.value) {
    error.value = "Por favor, insira seu e-mail.";
    return;
  }

  isLoading.value = true;

  try {
    await userStore.forgotPassword(email.value);

    emit("success", email.value);
  } catch (err) {
    error.value = err.message || "Erro ao solicitar. Tente novamente.";
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <div class="modal-backdrop">
    <div class="modal-panel">
      <div class="modal-header">
        <h3 class="modal-title">Esqueceu sua Senha?</h3>

        <button @click="emit('close')" type="button" class="modal-close-btn">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="modal-body">
          <p class="mb-4 text-sm text-gray-600">
            Insira seu endereço de e-mail. Enviaremos um código de 6 dígitos
            para redefinir sua senha.
          </p>

          <div class="form-group">
            <label for="email" class="form-label">E-mail</label>

            <input
              type="email"
              id="email"
              v-model="email"
              class="form-input"
              placeholder="seuemail@dominio.com"
              required
            />
          </div>

          <p v-if="error" class="error-message">{{ error }}</p>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            @click="emit('close')"
            class="btn btn-secondary"
          >
            Cancelar
          </button>

          <button
            type="submit"
            class="btn btn-primary"
            :disabled="isLoading || !email"
          >
            {{ isLoading ? "Enviando..." : "Enviar Código" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.modal-panel {
  max-width: 28rem;
}

.error-message {
  color: var(--danger);
  font-size: 0.875rem;
  margin-top: 1rem;
  text-align: center;
}
</style>